// Deterministic, offline placeholder thumbnails for the 5 named Standard
// product families (Bags, Mugs, Bottles, Umbrellas, Power Banks — the only
// Standard products this demo has, per the customer's own examples). Built as
// inline SVG data URIs instead of a stock-photo API so every thumbnail always
// depicts the right kind of product (a bottle photo service can't guarantee
// that), works offline, and never shows unrelated/inappropriate imagery.

const ICON_PATHS = {
  'Tote Bag': '<rect x="18" y="40" width="64" height="46" rx="5" fill="none"/><path d="M33 40 v-9 a7 7 0 0 1 14 0 v9" fill="none"/><path d="M53 40 v-9 a7 7 0 0 1 14 0 v9" fill="none"/>',
  'Coffee Mug': '<rect x="26" y="30" width="42" height="46" rx="4" fill="none"/><path d="M68 40 h10 a10 10 0 0 1 0 26 h-10" fill="none"/>',
  'Water Bottle': '<path d="M42 12 h16 v10 l6 8 v50 a6 6 0 0 1 -6 6 h-16 a6 6 0 0 1 -6 -6 v-50 l6 -8 z" fill="none"/><line x1="36" y1="46" x2="64" y2="46"/>',
  'Umbrella': '<path d="M15 46 A35 35 0 0 1 85 46 Q85 40 78 40 Q71 46 64 40 Q57 46 50 40 Q43 46 36 40 Q29 46 22 40 Q15 40 15 46 Z" fill="none"/><line x1="50" y1="46" x2="50" y2="85"/><path d="M50 85 q0 8 8 8" fill="none"/>',
  'Power Bank': '<rect x="28" y="18" width="44" height="64" rx="6" fill="none"/><rect x="44" y="10" width="12" height="8" rx="2"/><circle cx="50" cy="70" r="4"/>',
};

const COLOUR_HEX = {
  Natural: '#d8cdb8', White: '#f2f2f2', Silver: '#c7ccd1', Black: '#2b2b2b',
  Navy: '#1f2a44', Blue: '#2f6fb0', Red: '#c0392b', Grey: '#9aa0a6',
};

const isDarkHex = (hex) => {
  const value = hex.replace('#', '');
  const r = parseInt(value.substring(0, 2), 16);
  const g = parseInt(value.substring(2, 4), 16);
  const b = parseInt(value.substring(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 < 140;
};

export const PRODUCT_FAMILY_ICONS = Object.keys(ICON_PATHS);

export const buildProductFamilyThumbnail = (productFamily, colour) => {
  const iconPath = ICON_PATHS[productFamily];
  if (!iconPath) return null;

  const background = COLOUR_HEX[colour] || '#ada08a';
  const foreground = isDarkHex(background) ? '#f5f5f5' : '#2b2b2b';

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="480" height="360" viewBox="0 0 100 100">`
    + `<rect width="100" height="100" fill="${background}"/>`
    + `<g stroke="${foreground}" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="${foreground}">${iconPath}</g>`
    + `</svg>`;

  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};
